import type { RxCollection } from "rxdb";
import type { MigrationStrategies } from "./_types/migration-strategies";
import { INVOICE_MIGRATION_STRATEGIES } from "./invoice";

const SNAPSHOT_KEYS = ["losingLocal", "winner", "assumedMaster"] as const;

export const buildInvoiceConflictCaseMigrationStrategies = (
  invoiceStrategies: MigrationStrategies,
): MigrationStrategies =>
  Object.fromEntries(
    Object.entries(invoiceStrategies).map(([version, migrate]) => [
      version,
      async (oldCase: Record<string, unknown>, collection: RxCollection) => {
        const migratedCase = { ...oldCase };

        for (const key of SNAPSHOT_KEYS) {
          const snapshot = migratedCase[key];
          if (snapshot && typeof snapshot === "object") {
            const migratedSnapshot = await migrate(
              snapshot as Record<string, unknown>,
              collection,
            );

            // The invoice strategy dropping a snapshot drops the whole case:
            // a case without its documents has nothing left to resolve.
            if (migratedSnapshot === null) {
              return null;
            }

            migratedCase[key] = migratedSnapshot;
          }
        }

        return migratedCase;
      },
    ]),
  );

export const INVOICE_CONFLICT_CASE_MIGRATION_STRATEGIES: MigrationStrategies =
  buildInvoiceConflictCaseMigrationStrategies(INVOICE_MIGRATION_STRATEGIES);
